<template lang="pug">
modal(
  :no-footer='true'
  :title='$t("modal.consumptionReportModal.title")'
  ref='modal'
  size='sm'
)
  p {{ $t('modal.consumptionReportModal.message') }}
  .text-center.mt-5
    .d-flex.flex-column.flex-sm-row.justify-content-end.gap-2.gap-sm-4
      button.btn.btn-secondary.text-nowrap.w-100.w-sm-auto(
        @click='close'
        type='button'
      ) {{ $t('modal.consumptionReportModal.closeModal') }}
      button.btn.btn-primary.text-nowrap.w-100.w-sm-auto(
        @click='getConsumptionReport()'
        style='border-width: 1px'
        type='button'
      )
        span.text {{ $t('modal.consumptionReportModal.buttonLabel') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'ConsumptionReportModal',
  components: {
    Icon,
    Modal,
  },
  created() {},
  data() {
    return {};
  },
  methods: {
    getConsumptionReport() {
      this.$emit('consumption-report-modal');
      this.$refs.modal.close();
    },
    close() {
      this.$refs.modal.close();
    },
  },
};
</script>

<style scoped lang="stylus">
p
  font-size: 16px
  line-height: 24px
img
  margin: 32px
  width: 184.371px
  height: 155px
  flex-shrink: 0
button
  padding: 8px
  display: flex
  flex-direction: row
</style>
